import { render, staticRenderFns } from "./DocumentPartner.vue?vue&type=template&id=3faa00ce&scoped=true"
import script from "./DocumentPartner.vue?vue&type=script&lang=js"
export * from "./DocumentPartner.vue?vue&type=script&lang=js"
import style0 from "./DocumentPartner.vue?vue&type=style&index=0&id=3faa00ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faa00ce",
  null
  
)

export default component.exports